import Login from "../Login/Login";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import BusinessForm from "../pages/Contact/BusinessForm";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import LlmsEditor from "../pages/Llms/LlmsEditor";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";
import RoutePermissionGuard from "../hoc/RoutePermissionGuard";

export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route element={<RoutePermissionGuard />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />

          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />

          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />

          <Route path="contact" element={<Contact />} />
          <Route path="business-contact" element={<BusinessForm />} />
           <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          <Route path="llms" element={<LlmsEditor />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />
          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />

          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
          </Route>
        </Route>
      </Routes>
    </>
  )
}
